import { Search, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SidebarInput } from '@/components/ui/sidebar'
import useSidebar from '@/hooks/use-sidebar'
import { useEffect } from 'react'
import useSidebarSearch from '@/hooks/use-sidebar-search'

export function SidebarSearch() {
  const { searchQuery, setSearchQuery, clearSearch, isSearching } = useSidebarSearch()
  const { state } = useSidebar()

  // Clear search when sidebar is collapsed
  useEffect(() => {
    if (state === 'collapsed' && isSearching) clearSearch()
  }, [state, isSearching, clearSearch])

  return (
    <div
      id='sidebar-search'
      className={`relative px-2 py-2 transition-all duration-200 -mb-4 ${
        state === 'collapsed' ? 'opacity-0 pointer-events-none h-0 overflow-hidden' : 'opacity-100'
      }`}
    >
      <div className='relative'>
        <Search className='absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground' />
        <SidebarInput
          placeholder='Search menu...'
          value={searchQuery}
          onChange={(e) => {
            // Only accept genuine user input. Programmatic value changes -
            // browser autofill, saved-value restore, or form-filler extensions
            // like Fake Filler - dispatch untrusted events; reject and revert
            // them so the field only ever holds what the user actually typed.
            if (!e.nativeEvent.isTrusted) {
              e.currentTarget.value = searchQuery
              return
            }
            setSearchQuery(e.target.value)
          }}
          className='pl-8 pr-8'
          // Discourage browsers/password managers from offering saved values
          autoComplete='off'
          autoCorrect='off'
          autoCapitalize='off'
          spellCheck={false}
          name='sidebar-menu-search'
          data-lpignore='true'
          data-form-type='other'
          data-1p-ignore=''
        />
        {isSearching && (
          <Button
            variant='ghost'
            size='icon'
            className='absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 hover:bg-transparent'
            onClick={clearSearch}
          >
            <X className='h-3 w-3' />
            <span className='sr-only'>Clear search</span>
          </Button>
        )}
      </div>
    </div>
  )
}
